import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { Button, Grid, Typography } from '@mui/material'
import { omit, toLower, values } from 'lodash'
import { brutRgbMainBlue, mainWhite } from 'utils/constants/ColorTheme'
import { LARGE_RADIUS, LIGHT_BOX_SHADOW } from 'utils/constants/Theme'
import ModuleCard from './ModuleCard'

const LARGE_ZINDEX = 9999

const ObservatoryContent = ({
    filter = {},
    modules = [],
    modulesToDelete = [],
    setModuleToOpen = () => {},
    onDeleteModules,
    onCloseDelete = () => {},
    backdropped = false,
}) => {
    const filteredModules = filter.searchValue ? modules.filter(m => values(omit(m, ['token', 'headers'])).some(v => toLower(`${v}`).includes(toLower(filter.searchValue)))) : modules

    return (
        <Grid
            container
            direction='column'
            rowSpacing={3}
            sx={{
                position: 'relative',
                flex: 1,
                overflow: 'visible',
                zIndex: backdropped && LARGE_ZINDEX,

                border: 'solid 1px',
                borderColor: `rgba(${brutRgbMainBlue}, 0.4)`,
                padding: 1.5,
                backgroundColor: mainWhite,
                borderRadius: LARGE_RADIUS,
                boxShadow: LIGHT_BOX_SHADOW,
            }}
        >
            <Grid container size={12} alignItems='center'>
                <Grid container direction='column' size='grow' rowSpacing={0}>
                    <Typography variant='title'>
                        {!backdropped && i18n.moduleParametersScreenTitle}
                        {!!onDeleteModules && i18n.deletingModules}
                        {(backdropped && !onDeleteModules) && i18n.duplicatingModule}
                    </Typography>
                    <Typography variant='subtitle'>
                        {!backdropped && i18n.moduleParametersScreenSubTitle}
                        {!!onDeleteModules && i18n.deletingModuleParametersScreenSubTitle}
                        {(backdropped && !onDeleteModules) && i18n.duplicatingModuleParametersScreenSubTitle}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container spacing={1.5} sx={{ flex: 1, overflow: 'auto', alignContent: 'flex-start' }}>
                {filteredModules.map(mod => (
                    <Grid key={mod.login} size={{ xs: 12, sm: 6, md: 4, lg: 3 }} spacing={1.5}>
                        <ModuleCard
                            mod={mod}
                            selected={modulesToDelete.some(mtd => mtd.login === mod.login)}
                            setModuleToOpen={setModuleToOpen}
                            deselectable={!!onDeleteModules}
                        />
                    </Grid>
                ))}
            </Grid>
            {backdropped && (
                <Grid container size={12} columnSpacing={1} justifyContent='flex-end'>
                    <Button
                        variant='outlined'
                        onClick={onCloseDelete}
                    >
                        {i18n.cancel}
                    </Button>
                    {!!onDeleteModules && (
                        <Button
                            variant='contained'
                            onClick={onDeleteModules}
                        >
                            {i18n.validate}
                        </Button>
                    )}
                </Grid>
            )}
        </Grid>
    )
}

ObservatoryContent.propTypes = {
    displayIntro: PropTypes.bool,
    filter: PropTypes.shape({
        searchValue: PropTypes.string,
    }),
    modules: PropTypes.arrayOf(PropTypes.shape({})),
    modulesToDelete: PropTypes.arrayOf(PropTypes.shape({})),
    setModuleToOpen: PropTypes.func,
    setDisplayIntro: PropTypes.func,
    activeEasterEgg: PropTypes.false,
    onDeleteModules: PropTypes.func,
    onCloseDelete: PropTypes.func,
    backdropped: PropTypes.bool,
}

export default ObservatoryContent